/* src/app/components/consent/consent.component.scss */
.main-container {
  min-height: 100vh;
}
.apt-container {
  margin: 0;
}
.apt-container > .apt-grid,
.apt-container > .apt-grid-wrap {
  margin: 0 15px;
}
.apt-container .apt-grid.success-box {
  margin-bottom: 40px;
}
.apt-container .apt-grid.success-box .label-icon {
  font-size: 2rem;
}
.apt-container .apt-grid.success-box .label-icon img {
  width: 50px;
  height: auto;
}
.apt-container .apt-grid.success-box .label-thank-you {
  font-size: 1.6rem;
  line-height: 1.23077;
}
.apt-container .apt-grid.success-box .label-msg {
  font-size: 1.3rem;
  line-height: 1.6;
  font-weight: 600;
}
.apt-container .apt-grid.success-box .label-ref-number {
  font-size: 1.6rem;
  line-height: 1.23077;
}
.apt-container .form-action {
  text-align: left;
  margin-top: 20px;
}
.apt-container .form-action .btn {
  grid-column: span 3;
}
.comp-content {
  background-color: #f2f2f2;
}
.apt-grid,
.apt-grid-wrap {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  column-gap: 10px;
}
.apt-grid > *,
.apt-grid-wrap > * {
  grid-column: 1/-1;
}
.apt-grid-wrap > * {
  min-width: 0;
  min-height: 0;
  word-wrap: break-word;
  max-width: 100%;
}
.required-field label::after,
.required-field-label::after {
  content: " *";
  color: #e74a3b;
}
.required-field-notice {
  font-size: 0.8rem;
  margin-top: 18px;
  margin-bottom: 20px;
}
.required-field-notice::before {
  content: "* ";
  color: #e74a3b;
}
.button-like {
  min-height: 34px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  outline: 0;
  padding: 0.65em 0.75em;
  display: inline-block;
  position: relative;
  color: #212121;
  font-size: 13px;
  line-height: 1.2;
  vertical-align: middle;
  background-color: #fafafa;
  transition: none 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.button-like--with-icon {
  padding-right: 20px;
}
.button-like__icon {
  padding: 0.1em 5px;
  border: 0;
  outline: 0;
  position: absolute;
  top: 0;
  margin-top: -2px;
  right: 0;
  background: transparent;
  color: #c4c4c4;
  appearance: none;
  font-size: 25px;
}
.custom-control-label.custom-no-text::before {
  top: -0.75rem;
  left: -1rem;
}
.custom-control-label.custom-no-text::after {
  top: -0.75rem;
  left: -1rem;
}
.inline-action {
  font-size: 1.125rem;
  color: #39393a;
  text-decoration: underline;
  cursor: pointer;
}
.modal-showroom {
  max-width: 90vw;
}
@media only screen and (min-width: 480px) {
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 420px;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 768px) {
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 708px;
  }
  .modal-showroom {
    max-width: 85vw;
  }
}
@media only screen and (min-width: 1014px) {
  .required-field-notice {
    margin-top: 35px;
    margin-bottom: 40px;
    font-size: 1rem;
  }
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 953px;
  }
  .apt-container .form-action {
    display: flex;
    justify-content: flex-end;
  }
  .apt-container .form-action .btn:not(:last-child) {
    margin-right: 20px;
  }
  .apt-grid,
  .apt-grid-wrap {
    grid-template-columns: repeat(9, 1fr);
    column-gap: 20px;
  }
  .modal-xlg {
    max-width: 80%;
  }
}
@media only screen and (min-width: 1336px) {
  .apt-container > .apt-grid,
  .apt-container > .apt-grid-wrap {
    max-width: 1276px;
  }
  .apt-grid,
  .apt-grid-wrap {
    grid-template-columns: repeat(12, 1fr);
  }
}
@media only screen and (min-width: 768px) {
  .content {
    margin-top: 120px;
    position: relative;
    min-height: calc(100vh - 280px);
  }
  .content.public-header {
    margin-top: 76px;
  }
}
@media only screen and (min-width: 1336px) {
  .content {
    min-height: calc(100vh - 220px);
  }
}
.status-container {
  text-align: center;
}
.status-icon {
  width: 110px;
  height: 110px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}
.status-icon i {
  color: #fff;
  font-size: 58px;
}
.status-icon.success {
  background: #28a745;
}
.status-icon.alert {
  background: #dc3545;
}
.status-icon.acknowledged {
  background: #0d6efd;
}
.status-title {
  margin-top: 28px;
  font-size: 34px;
  font-weight: 900;
  letter-spacing: 2px;
}
.status-title.success {
  color: #000000;
}
.status-title.alert {
  color: #000000;
}
.status-title.acknowledged {
  color: #000000;
}
.status-message {
  margin-top: 10px;
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}
.apt-container .title {
  font-size: 2.25rem;
  margin: 24px 0;
  color: #115e67;
}
.apt-container .text-color {
  color: #000;
}
.apt-container .underline {
  text-decoration: underline;
}
.apt-container .pages-desc {
  margin-bottom: 22px;
}
.apt-container .table-row.table-header {
  font-size: 0.875rem;
  color: #39393a;
}
.apt-container .table-row.table-body {
  padding: 0;
  font-size: 1rem;
  background-color: #c9dce5;
  color: #000;
  vertical-align: baseline;
  border-bottom-width: 0;
}
.apt-container .table-row.table-body label {
  padding-top: 40px;
  padding-bottom: 40px;
  margin-bottom: 0;
  width: 100%;
  border-top-width: 0.5px;
  border-top-style: solid;
  border-top-color: #115e67;
}
.apt-container .table-row.table-body .text-decoration {
  font-family: "Maxis-Bold";
  text-decoration: none;
  cursor: pointer;
  color: #115e67;
  text-transform: uppercase;
  line-height: normal;
}
.apt-container .table-row.table-body .text-decoration img {
  margin-top: -3px;
}
.apt-container .table-row.table-body:first-of-type label {
  margin-left: 24px;
}
.apt-container .table-row.table-body:last-of-type label {
  padding-top: 40px;
  margin-right: 24px;
  width: calc(100% - 24px);
}
.apt-container .mat-row:first-of-type .table-body label,
.apt-container .mat-row:nth-child(2n+1) .table-body label {
  border-top-width: 0;
}
.apt-container .mat-row:nth-child(2n) .table-body {
  border-bottom-width: 2px;
}
.apt-container .paginator {
  margin-top: 32px;
  margin-bottom: 56px;
}
.apt-container .action .icon {
  cursor: pointer;
}
.apt-container .top-label {
  font-size: 12px;
  color: #7f7f7f;
}
.apt-container button.close:focus {
  outline: 0;
}
.apt-container .btn-search {
  margin-top: -5px;
}
.apt-container .btn {
  height: 50px;
  letter-spacing: 2.5px;
  min-width: 144px;
}
.apt-container .divider {
  margin-top: 32px;
  margin-bottom: 32px;
}
.apt-container .summary-status {
  display: flex;
  font-size: 0.875rem;
  margin-bottom: 32px;
  font-family: "Maxis-Semibold";
}
.apt-container .summary-status .status {
  border: 2px solid #3e4a56;
  border-radius: 15px;
  margin-right: 10px;
  padding: 3px 29px;
  cursor: pointer;
}
.apt-container .summary-status .status.actived {
  border-color: #00cc00;
}
.apt-container .filters {
  margin-top: 9px;
}
.apt-container .filters .case-id {
  grid-column: span 2;
}
.apt-container .filters .filter-string {
  grid-column: span 4;
}
.apt-container .filters .btn-search .btn {
  max-width: 173px;
  float: right;
  margin-top: 16px;
}
.apt-container .filters .date-range > input {
  background-color: #e8ecef;
}
.apt-container .not-found {
  position: relative;
  padding-bottom: 120px;
}
.apt-container .not-found div {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.apt-container .not-found div p {
  color: #3e4a56;
  font-size: 15px;
}
.apt-container .not-found div p.title {
  font-size: 1.375rem;
  font-family: "Maxis-Bold";
  margin: 0;
  margin-bottom: 16px;
}
.apt-container .footer {
  position: relative;
}
.apt-container .footer {
  position: relative;
  width: 100%;
  top: 100%;
}
.mt-20px {
  margin-top: 20px;
}
.category-tabs {
  display: block;
}
.category-tabs .tabs-component {
  display: flex;
  flex-wrap: wrap;
}
.category-tabs .tabs-component ul {
  padding: 0;
  display: inline-block;
  width: 20%;
  text-align: start;
  border-bottom: solid 1px #e5e5e5;
}
.category-tabs .tabs-component ul.actived {
  border-bottom: 3px solid #7ec237;
}
.category-tabs .tabs-component ul:hover {
  cursor: pointer;
}
.category-tabs .tabs-component ul a {
  display: block;
  padding: 10px 0 10px 20px;
  text-decoration: none;
  margin: 0;
  color: #000;
}
@media screen and (max-width: 1014px) {
  .apt-container .btn-search-nric {
    display: flex !important;
    column-gap: 15px;
    justify-content: end;
  }
  .apt-container .btn-maxis-cta {
    font-size: 0.8em !important;
  }
}
@media screen and (max-width: 768px) {
  .apt-container .col-md-6 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media only screen and (min-width: 1014px) {
  .apt-container .filters .case-id {
    grid-column: span 3;
  }
  .apt-container .filters .btn-search {
    grid-column: span 1;
  }
  .apt-container .filters .btn-search .btn {
    max-width: inherit;
    margin-top: 0;
  }
  .apt-container .filters .filter-string {
    grid-column: span 5;
  }
}
@media only screen and (min-width: 1336px) {
  .apt-container .pages-desc {
    margin-bottom: 26px;
  }
  .apt-container .divider {
    margin-top: 35px;
    margin-bottom: 35px;
  }
  .apt-container .summary-status {
    margin-bottom: 29px;
  }
  .apt-container .filters .case-id,
  .apt-container .filters .btn-search {
    grid-column: span 3;
  }
  .apt-container .filters .filter-string {
    grid-column: span 6;
  }
}
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.custom-modal-content {
  width: 55dvw;
  height: 55dvh;
  background: white;
  border: none;
  text-align: center;
  color: darkgreen;
}
.custom-modal-content h2 {
  font-size: clamp(18px, 4vw, 32px);
}
button.btn:hover {
  text-decoration: none;
  letter-spacing: 1px !important;
}
.flip-horizontal {
  transform: scaleX(-1);
  display: inline-block;
}
.letter-spacing-1 {
  letter-spacing: 1px;
}
/*# sourceMappingURL=consent.component.css.map */
